import TextField from "@mui/material/TextField";
import { makeStyles } from "@mui/styles";
import clsx from "clsx";
import React, { KeyboardEventHandler, useState } from "react";

interface Props {
    type?: React.InputHTMLAttributes<unknown>["type"];
    onChanged?: (newValue: string) => void;
    className?: string;
    disabled?: boolean;
    required?: boolean;
    testId?: string;
    label: string;
    value: string;
    onKeyPress?: KeyboardEventHandler;
    checkIsValid?: () => boolean;
    invalidMessage?: string;
    numRows?: number;
    maxRows?: number;
    endAdornment?: React.ReactNode;
    usePlaceholder?: boolean;
    autoFocus?: boolean;
    step?: number;
}

const useStyles = makeStyles(() => ({
    root: {
        marginBottom: "12px"
    }
}));

const SettingsTextField: React.FC<Props> = props => {
    const classes = useStyles();
    const multiline = (props.numRows !== undefined && props.numRows > 1)
        || (props.maxRows !== undefined && props.maxRows > 1);

    const [isValid, setIsValid] = useState(true);
    const onBlur = () => {
        if (props.checkIsValid !== undefined && props.invalidMessage) {
            setIsValid(props.checkIsValid());
        }
    };

    return (
        <TextField
            data-cy={props.testId}
            onKeyPress={props.onKeyPress}
            autoFocus={props.autoFocus}
            required={props.required}
            InputProps={{ endAdornment: props.endAdornment }}
            label={props.usePlaceholder ? undefined : props.label}
            helperText={isValid ? "" : props.invalidMessage}
            error={!isValid}
            variant="outlined"
            size="small"
            placeholder={props.usePlaceholder ? props.label : undefined}
            type={props.type}
            className={clsx(classes.root, props.className)}
            disabled={props.disabled}
            // eslint-disable-next-line react/jsx-no-duplicate-props
            inputProps={{ step: props.step }}
            onChange={e => props.onChanged && props.onChanged(e.target.value)}
            value={props.value}
            minRows={props.numRows}
            maxRows={props.maxRows}
            onBlur={onBlur}
            multiline={multiline} />
    );
};

export default SettingsTextField;
